import React from 'react';
import './Onboarding.css';

/**
 * Medium selector component - automatically selects Novel.
 * First step of the onboarding flow.
 */
function MediumSelector({ onSelect }) {
  return (
    <div className="medium-selector">
      <h1 className="medium-selector__title">Welcome to Brainstormy</h1>
      <p className="medium-selector__subtitle">What are you writing?</p>

      <div className="medium-selector__options">
        <button
          className="medium-selector__option"
          onClick={() => onSelect('novel')}
          aria-label="Select Novel"
        >
          <span className="medium-selector__icon" role="img" aria-hidden="true">
            📖
          </span>
          <span className="medium-selector__label">Novel</span>
          <span className="medium-selector__description">
            Prose fiction with rich interiority
          </span>
        </button>
      </div>
    </div>
  );
}

export default MediumSelector;
